export default {
  init() {
    // JavaScript to be fired on the about us page
    const urlParams = new URLSearchParams(window.location.search);
    const orderNow = urlParams.get('order');
    if (orderNow === 'autoload') {
      $('#requestModal').modal('show')
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/products.js